export default class Device {
  constructor({type, uid, fcmRegistrationToken = null}) {
    if (arguments) {
      this.type = type.rawValue;
      this.uid = uid;
      this.fcmRegistrationToken = fcmRegistrationToken;
    }
  }
}
